<template>
  <div class="list-panel">
    <el-card type="form-card" v-loading="loading">
      <div class="basic-info">
        <span class="color_primary noline-text contract-name">{{ contractName }}</span>
        <span :class="['color_' + contractConfig.getAppointed('status_color', contractStatus)]">（{{ contractConfig.getAppointed("status_summary", contractStatus, '') }}）</span>
        <el-divider class="vline" direction="vertical"></el-divider>
        <span class="noline-text">客户名称：{{ customerName }}</span>
        <span class="noline-text">品牌名称：{{ brandName }}</span>
        <el-divider class="vline" direction="vertical"></el-divider>
        <span class="noline-text">投放次数：{{ putInNum }}</span>
        <span class="noline-text">总执行价：{{ readableNum(contractExecuteMoney) }}</span>
        <span class="noline-text">博主其他总成本：{{ readableNum(contractOtherCostAll) }}</span>
        <span class="noline-text">分成总收入：{{ readableNum(contractShareMoneyAll) }}</span>
      </div>
      <div class="table-wrap">
        <el-table :data="tableData" v-loading="tableLoading" size="mini">
          <el-table-column label="投放编号" prop="code" align="center"></el-table-column>
          <el-table-column label="博主名称" prop="bloggerName">
            <template slot-scope="scope">
              <div class="account-wrap">
                <div class="avatar-out">
                  <div class="avatar-in">
                    <div class="img-wrap" v-if="scope.row.avatar">
                      <!--有头像-->
                      <img v-if="scope.row.avatar.indexOf('/qr/code') !== -1" :src="scope.row.avatar" onerror="javascript:this.src='/img/media/wechat_default.png';" class="avatar is-code">
                      <img v-else :src="scope.row.avatar" onerror="javascript:this.src='/img/media/weibo_default.png';" class="avatar">
                    </div>
                    <div class="img-wrap" v-else>
                      <img src="/img/media/weibo_default.png" class="avatar">
                    </div>
                  </div>
                </div>
                <div class="info-wrap">
                  <el-tooltip :content="scope.row.bloggerName" placement="bottom" effect="light">
                    <div class="nickname"><span>{{ scope.row.bloggerName }}</span></div>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="平台" align="center" width="50">
            <template slot-scope="scope">
              {{ mediaConfig.getAppointed("media_ch", scope.row.mediaType, '') }}
            </template>
          </el-table-column>
          <el-table-column label="发布形式" prop="publishType" align="center"></el-table-column>
          <el-table-column label="发布日期" prop="publishTime" align="center">
            <template slot-scope="scope">
              {{ scope.row.publishTime ? scope.row.publishTime.split(' ')[0] : '' }}
            </template>
          </el-table-column>
          <el-table-column label="执行价" prop="executePrice" align="center">
            <template slot-scope="scope">
              {{ readableNum(scope.row.executePrice) }}
            </template>
          </el-table-column>
          <el-table-column label="博主其他成本" prop="bloggerOtherCost" align="center">
              <template slot-scope="scope">
              {{ readableNum(scope.row.bloggerOtherCost) }}
            </template>
          </el-table-column>
          <el-table-column label="分成基数金额" prop="shareIncome" align="center">
              <template slot-scope="scope">
              {{ readableNum(scope.row.shareIncome) }}
            </template>
          </el-table-column>
          <el-table-column label="投放状态" prop="publishType" align="center">
            <template slot-scope="scope" prop="status">
              {{ deliveryConfig.getAppointed("delivery_status", scope.row.status, '') }}
            </template>
          </el-table-column>
          <el-table-column label="结算状态" prop="settleStatus" align="center">
            <template slot-scope="scope">
              {{ deliveryConfig.getAppointed("settle_status", scope.row.settleStatus, '') }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="90">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="toRelateDetail(scope.row.id)">查看投放详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-wrap">
          <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="page.total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import util from "@/util/util";
import { contractConfig } from "@/const/config/contract";
import { mediaConfig } from "@/const/config/media";
import { deliveryConfig } from "@/const/config/delivery";
import { getContractDelivery } from "@/api/business/contract";
export default {
  data() {
    return {
      contractConfig: contractConfig,
      mediaConfig: mediaConfig,
      deliveryConfig: deliveryConfig,

      //总相关
      contractName: "",
      contractStatus: null,
      customerName: "",
      brandName: "",
      putInNum: "",
      contractExecuteMoney: "",
      contractOtherCostAll: "",
      contractShareMoneyAll: "",
      tableData: [],
      loading: false,
      tableLoading: false,
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    getList() {
      let queryObj = {
        mediaType: this.$route.query.mtype,
        mediaId: this.$route.query.mid,
        contractId: this.$route.query.cid,
      };
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      this.tableLoading = true;
      getContractDelivery(queryObj)
        .then((res) => {
          //基础信息
          this.contractName = res.name;
          this.contractStatus = res.status;
          this.customerName = res.customerName;
          this.brandName = res.brandName;
          //统计信息
          this.putInNum = res.putInNum;
          this.contractExecuteMoney = res.contractExecuteMoney;
          this.contractOtherCostAll = res.contractOtherCostAll;
          this.contractShareMoneyAll = res.contractShareMoneyAll;
          //合同列表
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          //基础信息
          this.accountName = "";
          this.accountFansNum = "";
          this.accountAvatar = "";
          this.accountUrl = "";
          //统计信息
          this.putInNum = "";
          this.executeMoneyAll = "";
          this.otherCostAll = "";
          this.shareMoneyAll = "";
          //合同列表
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    toRelateDetail(id) {
      let router = this.$router.resolve({
        path: "/business/delivery-log/show",
        query: {
          id,
        },
      });
      window.open(router.href, "_blank");
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-info {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 14px;
}
//账号名称
.account-wrap {
  display: flex;
  cursor: pointer;
  //头像
  .avatar-out {
    /*width: 50%;*/
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .avatar-in {
      position: relative;
      width: 42px;
      height: 42px;
      margin-right: 10px;
      float: right;
      .img-wrap {
        position: relative;
        border-radius: 50%;
        width: 42px;
        height: 42px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          &.is-code {
            position: absolute;
            top: -84px;
            left: -84px;
            width: 210px;
            height: 210px;
          }
        }
      }
    }
  }
  //基础信息
  .info-wrap {
    display: flex;
    align-items: center;
    width: 50%;
    font-size: 12px;
    text-align: left;
    .nickname {
      max-width: 65px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.vline {
  margin: 0 15px;
  background-color: #999;
}
.noline-text {
  margin-right: 10px;
}
.contract-name {
  font-size: 16px;
}
.table-wrap {
  margin-top: 30px;
}
</style>